import { render, staticRenderFns } from "./BudgetList.html?vue&type=template&id=683763f8&scoped=true&"
import script from "./BudgetList.component.js?vue&type=script&lang=js&"
export * from "./BudgetList.component.js?vue&type=script&lang=js&"
import style0 from "./BudgetList.scss?vue&type=style&index=0&id=683763f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683763f8",
  null
  
)

export default component.exports